<script setup>
import { ref, computed, onUnmounted } from "vue";

const props = defineProps({
	text: {
		type: String,
		default: "Скопировано",
	},
	duration: {
		type: Number,
		default: 2000,
	},
});

const isVisible = ref(false);
const copyTooltip = ref(null);
let timer = null;

const heightTooltip = computed(() => {
	if (copyTooltip.value) {
		return `${copyTooltip.value.offsetHeight}px`;
	}
})

const show = async (text) => {
	isVisible.value = true;

	clearTimeout(timer);
	timer = setTimeout(() => {
		isVisible.value = false;
	}, props.duration);

	await navigator.clipboard.writeText(text);

};

onUnmounted(() => {
	clearTimeout(timer);
});
</script>

<template>
	<button :class="['copy-tooltip', {active: isVisible}]" ref="copyTooltip">
		<slot :show="show" />
		<Transition name="fade">
			<span v-if="isVisible" class="copy-tooltip__text" :style="{ top: heightTooltip }">
				{{ text }}
			</span>
		</Transition>
	</button>
</template>

<style lang="scss" scoped>
@use "@/assets/scss/base/vars";
.copy-tooltip {
	position: relative;
	display: inline-flex;
    &__text  {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-90%);
       	font-weight: 900;
		font-size: 1.4rem;
		line-height: 160%;
		text-align: center;
        color: var(--fill-inverse-1);
		backdrop-filter: blur(14.199999809265137px);
		box-shadow: 0 4px 0 0 var(--brand-accent-1-100);
		background: var(--fill-default-1);
        border: 1px solid var(--border-accent-1-1);
		border-radius: 1.2rem;
        padding: .8rem 1.6rem;
        white-space: nowrap;
        pointer-events: none;
		text-transform: none;
    }
	&.active {
		z-index: 2;
	}
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.2s ease;
}
.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}
</style>
